import { render } from "./ShopperHelpPage.vue?vue&type=template&id=3d68ddb3"
import script from "./ShopperHelpPage.vue?vue&type=script&lang=js"
export * from "./ShopperHelpPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__